"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/*
This file maps exports from `aws-amplify/storage/s3/server`. It provides access to server context enabled S3 APIs.
*/
tslib_1.__exportStar(require("@aws-amplify/storage/s3/server"), exports);
